export const INIT = 'STATIC_VIEW/INIT';
export const INIT_FINISH = 'STATIC_VIEW/INIT_FINISH';

export const GET_DATA_START = 'STATIC_VIEW/GET_DATA_START';
export const GET_DATA_SUCCESS = 'STATIC_VIEW/GET_DATA_SUCCESS';
export const GET_DATA_FAIL = 'STATIC_VIEW/GET_DATA_FAIL';

export const GET_DATA_NEXT_PAGE_START = 'STATIC_VIEW/GET_DATA_NEXT_PAGE_START';
export const GET_DATA_NEXT_PAGE_SUCCESS = 'STATIC_VIEW/GET_DATA_NEXT_PAGE_SUCCESS';
export const GET_DATA_NEXT_PAGE_FAIL = 'STATIC_VIEW/GET_NEXT_PAGE_FAIL';

export const SET_SELECTED = 'STATIC_VIEW/SET_SELECTED';
export const SET_PAGE = 'STATIC_VIEW/SET_PAGE';
export const SET_ORDER = 'STATIC_VIEW/SET_ORDER';
export const SET_LOADING = 'STATIC_VIEW/SET_LOADING';
export const SET_SEARCH = 'STATIC_VIEW/SET_SEARCH';
export const SET_DETAILS_LOADING = 'STATIC_VIEW/SET_DETAILS_LOADING';

export const COLUMNS_SAVE_USER_SETUP_START = 'STATIC_VIEW/COLUMNS_SAVE_USER_SETUP_START';
export const COLUMNS_SAVE_USER_SETUP_SUCCESS = 'STATIC_VIEW/COLUMNS_SAVE_USER_SETUP_SUCCESS';

export const COLUMNS_GET_CONFIG_SUCCESS = 'STATIC_VIEW/COLUMNS_GET_CONFIG_SUCCESS';
export const COLUMNS_GET_CONFIG_FAIL = 'STATIC_VIEW/COLUMNS_GET_CONFIG_FAIL';

export const COLUMNS_CHANGE_SORTING = 'STATIC_VIEW/COLUMNS_CHANGE_SORTING';

export const FILTERS_GET_CONFIG_SUCCESS = 'STATIC_VIEW/FILTERS_GET_CONFIG_SUCCESS';
export const FILTERS_GET_CONFIG_FAIL = 'STATIC_VIEW/FILTERS_GET_CONFIG_FAIL';

export const FILTERS_SELECT_VALUES = 'STATIC_VIEW/FILTERS_SELECT_VALUES';
export const FILTERS_OPEN_CATEGORY = 'STATIC_VIEW/FILTERS_OPEN_CATEGORY';
export const FILTERS_CLOSE_CATEGORY = 'STATIC_VIEW/FILTERS_CLOSE_CATEGORY';

export const RECORD_GET_DETAILS_START = 'STATIC_VIEW/RECORD_GET_DETAILS_START';
export const RECORD_GET_DETAILS_FAIL = 'STATIC_VIEW/RECORD_GET_DETAILS_FAIL';
export const RECORD_GET_DETAILS_SUCCESS = 'STATIC_VIEW/RECORD_GET_DETAILS_SUCCESS';

export const FILTERS_REFRESH_VALUES_SUCCESS = 'STATIC_VIEW/FILTERS_REFRESH_VALUES_SUCCESS';
export const FILTERS_REFRESH_VALUES_FAIL = 'STATIC_VIEW/FILTERS_REFRESH_VALUES_FAIL';

export const REFRESH_DATA_START = 'STATIC_VIEW/REFRESH_DATA_START';

export const SYNC_DATA_WITH_CACHE_START = 'STATIC_VIEW/SYNC_DATA_WITH_CACHE_START';
export const SYNC_DATA_WITH_CACHE_SUCCESS = 'STATIC_VIEW/SYNC_DATA_WITH_CACHE_SUCCESS';
export const SYNC_DATA_WITH_CACHE_FAIL = 'STATIC_VIEW/SYNC_DATA_WITH_CACHE_FAIL';

export const SET_DATA_AFTER_SORT = 'STATIC_VIEW/SET_DATA_AFTER_SORT';
